import React from "react";
import { useSelector } from "react-redux";
import TourCard from "./tourCard";

const TourGrid = ({ year, onMoreInfo, onPhotos, onVideo }) => {
  const months = useSelector((state) =>
    Object.values(state.tour.byDate[year] || {})
  );

  if (!months || months.length === 0) return null;

  const getToursSet = (months) => {
    const allToursSet = new Set();
    months.forEach((month) => {
      Array.from(month).forEach((tourByMonth) => allToursSet.add(tourByMonth));
    });
    return allToursSet;
  };

  const allToursSet = getToursSet(months);
  const allTours = Array.from(allToursSet);

  if (allTours.length === 0) return null;

  // Sort tours by start date
  const sortedTours = allTours.sort((a, b) => {
    if (!a.performances || !b.performances) return 0;
    if (a.performances.length === 0 || b.performances.length === 0) return 0;

    const aStartDate = a.performances[0]?.asset?.startDate;
    const bStartDate = b.performances[0]?.asset?.startDate;

    if (!aStartDate || !bStartDate) return 0;

    // Compare by year, then month, then day
    if (aStartDate.year !== bStartDate.year) {
      return aStartDate.year - bStartDate.year;
    }
    if (aStartDate.month !== bStartDate.month) {
      return aStartDate.month - bStartDate.month;
    }
    return aStartDate.day - bStartDate.day;
  });

  // Group tours into rows (3 tours per row for compact design)
  // Limited to 2 rows maximum to prevent page layout issues
  const toursPerRow = 3;
  const maxRows = 2;
  const maxTours = maxRows * toursPerRow; // 6 tours maximum

  const tourRows = [];
  const toursToShow = sortedTours.slice(0, maxTours); // Only take first 6 tours

  for (let i = 0; i < toursToShow.length; i += toursPerRow) {
    tourRows.push(toursToShow.slice(i, i + toursPerRow));
  }

  return (
    <div className="tour-grid">
      {tourRows.map((row, rowIndex) => (
        <div key={`tour-row-${rowIndex}`} className="tour-grid-row">
          {row.map((tour, cardIndex) => (
            <TourCard
              key={`tour-card-${tour._id || cardIndex}`}
              tour={tour}
              onMoreInfo={onMoreInfo}
              onPhotos={onPhotos}
              onVideo={onVideo}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TourGrid;
